import Reveal from "./Reveal";

const proofPoints = [
  {
    quote: "The path finally feels clear.",
    label: "Direction",
    copy: "Decisions are visible, tradeoffs are explained, and the next useful move is always understood.",
  },
  {
    quote: "The product feels like ours.",
    label: "Ownership",
    copy: "The result reflects your customers, your operations, and the character of your business—not an agency template.",
  },
  {
    quote: "We know what happens next.",
    label: "Momentum",
    copy: "Progress arrives in testable increments, so feedback is useful and launch never feels like a leap into the dark.",
  },
];

const ProofSection = () => (
  <section className="proof-section">
    <div className="site-container">
      <Reveal className="proof-heading" direction="left">
        <p className="section-kicker">The experience we work to earn</p>
        <h2>What a strong partnership should sound like.</h2>
        <p>These are the standards behind every CMJ engagement—and the feedback we want the work to deserve.</p>
      </Reveal>
      <div className="proof-grid">
        {proofPoints.map((point, index) => (
          <Reveal key={point.label} delay={index * 110} direction={index === 1 ? "up" : index === 0 ? "left" : "right"}>
            <article className="proof-card">
              <span className="proof-index">0{index + 1} / {point.label}</span>
              <blockquote>“{point.quote}”</blockquote>
              <p>{point.copy}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default ProofSection;
